import React from "react";
import Highcharts from "highcharts";
import { renderToString } from "react-dom/server";
import { Theme } from "@mui/material";

export const getCommonHighchartsOptions = (
  theme: Theme
): Highcharts.Options => {
  return {
    credits: {
      enabled: false,
    },
    tooltip: {
      borderRadius: 4,
      borderColor: "transparent",
      backgroundColor: "transparent",
      shadow: false,
      style: {
        boxShadow: "none",
        fontFamily: "var(--ff-font-family-base)",
        fontWeight: "400",
        fontSize: theme.typography.caption.fontSize as string,
      },
      useHTML: true,
      shape: "square",
      stickOnContact: true,
    },
    chart: {
      zooming: { mouseWheel: false },
      backgroundColor: "transparent",
      plotBackgroundColor: "transparent",
      height: 330,
    },
    legend: {
      labelFormatter: function () {
        return renderToString(
          <div
            style={{
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.body3.fontSize,
              color: theme.palette.text.secondary,
              lineHeight: "18px",
              fontWeight: 500,
            }}
          >
            {this.name}
          </div>
        );
      },
      useHTML: true,
      align: "left",
      symbolHeight: 8,
      symbolWidth: 8,
      symbolRadius: 4,
      symbolPadding: 8,
      squareSymbol: false,
    },
  };
};
